module.exports = __webpack_public_path__ + "ee1bde286c475f1698830b53b1ab6bbc.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/difficulty_5_b.png
// module id = 50
// module chunks = 0